
(function($){
    const FullPageTitle = $(document).attr('title')
    const pageTitle = FullPageTitle.split('|')[0];

    $('#gform_1').on('click', function() {
        sendEvent(petaGA_FormCategory_DataCollect, petaGA_FormAction_Initiated, pageTitle )
    })
    
    $('#gform_1').on('submit', function() {
        sendEvent(petaGA_FormCategory_DataCollect, petaGA_FormAction_Submitted, pageTitle )
    })

})(jQuery);